import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'td-company-suspension-banner',
  templateUrl: './company-suspension-banner.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CompanySuspensionBannerComponent implements OnInit, OnDestroy {
  @HostBinding('class') public classes = 'company-suspension-warning';

  public companyIsSuspended = false;
  public dismissed = false;

  @HostBinding('class.company-suspended')
  public get isVisible(): boolean {
    return this.companyIsSuspended && !this.dismissed;
  }

  private sub?: Subscription;

  constructor(private auth: AuthService, private cd: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.sub = this.auth.userInfo$.subscribe((userInfo) => {
      this.companyIsSuspended = !!userInfo?.isCompanySuspendedFromWorking;
      this.cd.markForCheck();
    });
  }

  public dismiss(): void {
    this.dismissed = true;
    this.cd.markForCheck();
  }

  public ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
